var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeWithEyelashes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.3522,
    cy: 16.3522,
    r: 2.35224,
    fill: "#5FD0FB",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3407 3.9998C13.3407 3.61321 13.0273 3.2998 12.6407 3.2998C12.2541 3.2998 11.9407 3.61321 11.9407 3.9998V5.82589C11.9407 6.21249 12.2541 6.52589 12.6407 6.52589C13.0273 6.52589 13.3407 6.21249 13.3407 5.82589V3.9998Z",
    fill: "#011E29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44001 6.54831C6.16665 6.27494 5.72343 6.27494 5.45007 6.54831C5.1767 6.82168 5.1767 7.26489 5.45007 7.53826L6.66746 8.75565C6.94082 9.02902 7.38404 9.02902 7.65741 8.75565C7.93077 8.48228 7.93077 8.03907 7.65741 7.7657L6.44001 6.54831Z",
    fill: "#011E29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8313 7.53826C20.1047 7.26489 20.1047 6.82168 19.8313 6.54831C19.558 6.27494 19.1147 6.27494 18.8414 6.54831L17.624 7.7657C17.3506 8.03907 17.3506 8.48228 17.624 8.75565C17.8973 9.02902 18.3406 9.02902 18.6139 8.75565L19.8313 7.53826Z",
    fill: "#011E29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6406 10.5689C9.13122 10.5689 6.92788 13.331 6.27492 14.7302C6.11144 15.0805 5.69491 15.232 5.34458 15.0685C4.99425 14.905 4.84278 14.4885 5.00627 14.1381C5.7736 12.4939 8.35867 9.16895 12.6406 9.16895C16.9225 9.16895 19.5076 12.4939 20.2749 14.1381C20.4384 14.4885 20.2869 14.905 19.9366 15.0685C19.5863 15.232 19.1698 15.0805 19.0063 14.7302C18.3533 13.331 16.15 10.5689 12.6406 10.5689Z",
    fill: "#011E29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9906 14.9998C9.9906 13.5363 11.177 12.3498 12.6406 12.3498C14.1042 12.3498 15.2906 13.5363 15.2906 14.9998C15.2906 16.4634 14.1042 17.6498 12.6406 17.6498C11.177 17.6498 9.9906 16.4634 9.9906 14.9998ZM12.6406 13.6498C11.895 13.6498 11.2906 14.2542 11.2906 14.9998C11.2906 15.7454 11.895 16.3498 12.6406 16.3498C13.3862 16.3498 13.9906 15.7454 13.9906 14.9998C13.9906 14.2542 13.3862 13.6498 12.6406 13.6498Z",
    fill: "#011E29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeWithEyelashes);
export default __webpack_public_path__ + "static/media/eye-with-eyelashes.a95562c94c14129886c808db1038875f.svg";
export { ForwardRef as ReactComponent };